<template>
  <div class="machine_list_container">
    <DxDataGrid
      ref="machineGrid"
      class="machine_grid"
      :element-attr="gridAttributes"
      :data-source="dataSource"
      :no-data-text="$t('common.no_data_found')"
      :show-column-headers="false"
      :hover-state-enabled="true"
      :remote-operations="isRemoteOperation"
      :repaint-changes-only="true"
      height="100%"
      :columns="dataColumns"
      @row-click="onRowClick"
      :selected-row-keys="selectedMachines"
      @selection-changed="onGridSelectionChanged($event)"
    >
      <DxSelection :mode="multiselect ? 'multiple' : 'single'" showCheckBoxesMode="always" />
      <DxFilterRow :visible="true" />
      <DxPaging :enabled="true" />
      <DxScrolling mode="infinite" />
      <DxGrouping :autoExpandAll="true" />
      <DxGroupPanel :visible="false" />
    </DxDataGrid>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { DxDataGrid, DxColumn, DxSelection, DxFilterRow, DxScrolling, DxGrouping, DxGroupPanel, DxPaging } from "devextreme-vue/data-grid";
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";

export default {
  name: "MachineSelector",
  props: {
    localDataset: {
      type: Array,
      default: () => [],
    },
    dataColumns: {
      type: Array,
      default: () => [
        { dataField: "name", caption: "Denumire" },
        { dataField: "registration_number", caption: "Nr. inregistrare" },
      ],
    },
    multiselect: {
      type: Boolean,
      default: () => false,
    },
    isRemoteOperation: {
      type: Boolean,
      default: () => true,
    },
    selectedMachines: {
      type: Array,
      default: () => [],
    },
    // Optional payload to pass to loader (e.g., { autopropulsat: 1 })
    loaderPayload: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      gridAttributes: {
        class: "grid_general_mobile_style",
      },
    };
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxFilterRow,
    DxScrolling,
    DxGrouping,
    DxGroupPanel,
    DxPaging,
  },
  computed: {
    dataSource() {
      if (this.isRemoteOperation) {
        return this.customStore;
      }
      return this.localDataset;
    },
    customStore() {
      const self = this;
      return new DataSource({
        store: new CustomStore({
          load: async (loadOptions) => {
            try {
              // Merge loaderPayload into loadOptions
              loadOptions = { ...loadOptions, ...this.loaderPayload };
              const data = await self.getWorkMachines(loadOptions);
              // getWorkMachines resolves with data.data
              return Array.isArray(data?.data) ? data.data : [];
            } catch (e) {
              return [];
            }
          },
          byKey: async function (key) {
            return new Promise((resolve) => resolve("success"));
          },
        }),
      });
    },
  },
  methods: {
    ...mapActions({
      getWorkMachines: "works-work-machines/getWorkMachines",
    }),
    onRowClick(e) {
      if (!this.multiselect) {
        return;
      }

      if (e.rowType !== "data") {
        return;
      }

      const rowKey = e.key;
      const selectedIndex = this.selectedMachines.indexOf(rowKey);

      if (selectedIndex === -1) {
        this.selectedMachines.push(rowKey);
      } else {
        this.selectedMachines.splice(selectedIndex, 1);
      }

      this.$refs.machineGrid.instance.selectRows(this.selectedMachines, false);
    },
    onGridSelectionChanged(e) {
      this.$emit("update:selectedMachines", e.selectedRowKeys);
    },
    getSelectedMachines() {
      return this.$refs.machineGrid.instance.getSelectedRowKeys();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/dxMobileGridGeneral.scss";

.machine_list_container {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  padding-right: 5px;
}
</style>
